export const enum PickerTitle {
    CHOOSE_PERIOD = 'choose_period',
    // CURRENT_WEEK = 'current_week',
    PREVIOUS_SEVEN_DAYS = 'previous_seven_days',
    PREVIOUS_WEEK = 'previous_week',
    CURRENT_MONTH = 'current_month',
    PREVIOUS_MONTH = 'previous_month',
    CURRENT_QUARTER = 'current_quarter',
}
